import axios from 'axios.js'

export async function fiscalApi(action, payload = {}) {
    const response = await axios.post(`/api/fiscal/${action}`, payload)
    if (response.data?.error) {
        const error = new Error(response.data.errorInfo || 'Ошибка фискализации')
        // Some legacy response helpers retain HTTP 200. Only an explicit server classification is safe to unlock.
        const status = response.data.expected_error === true ? Number(response.data.status_code) : Number(response.status)
        error.response = { ...response, status }
        throw error
    }
    return response.data.data
}

export const fiscalError = (error) => {
    const message = error?.response?.data?.errorInfo || error?.message
    if (typeof message === 'string' && /[А-Яа-яЁё]/.test(message)) return message
    if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') return 'Сервер не ответил вовремя. Перед повторной отправкой проверьте состояние задания.'
    if (error?.message === 'Network Error') return 'Нет связи с сервером. Проверьте подключение к интернету.'
    return 'Не удалось выполнить действие. Обновите состояние задания или обратитесь к администратору.'
}
export const fiscalMoney = (minor) => (Number(minor || 0) / 100).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
export const fiscalStates = {
    prepared: 'Подготовлен', queued: 'В очереди', processing: 'Обрабатывается', succeeded: 'Фискализирован',
    unknown: 'Нужна проверка результата', failed_final: 'Отклонён', cancelled_before_send: 'Отменён до отправки',
    external_confirmed: 'Внешний чек подтверждён',
    manual_review: 'Требуется сверка',
}
